import { render, staticRenderFns } from "./IssueSeverityChipTableCell.vue?vue&type=template&id=2b81cfbf&scoped=true"
import script from "./IssueSeverityChipTableCell.vue?vue&type=script&lang=js"
export * from "./IssueSeverityChipTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueSeverityChipTableCell.vue?vue&type=style&index=0&id=2b81cfbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81cfbf",
  null
  
)

export default component.exports